// services/clinicService.js
import axios from '@/axios'

export default {
  async fetchAll() {
    const response = await axios.get('/clinics')
    return response.data.clinics
  },

  async fetchById(id) {
    const clinics = await this.fetchAll()
    return clinics.find(clinic => Number(clinic.id) === Number(id)) || null
  },

  async create(data) {
    return await axios.post('/admin/clinics', data)
  },
  async setActive(id, active) {
    return axios.post(`/admin/clinics/${id}/deactivate`, {
      is_active: active,
      _method: 'PATCH'
    })
  },


  async setSubscriptionUntil(id, date) {
    return axios.post(`/admin/clinics/${id}/subscription`, {
      subscription_until: date,
      _method: 'PATCH'
    })
  },

  async remove(id) {
    return await axios.delete(`/admin/clinics/${id}`)
  }
}
